import AGREGAR_GRUPO_OBRA from '@/graphql/mutations/administracion/catalogos/grupos.obras/agregarCatalogoGrupoObra.gql';
import ACTUALIZAR_GRUPO_OBRA from '@/graphql/mutations/administracion/catalogos/grupos.obras/actualizarCatalogoGrupoObra.gql';
import ELIMINAR_GRUPO_OBRA from '@/graphql/mutations/administracion/catalogos/grupos.obras/removerCatalogoGrupoObra.gql';
import OBTENER_GRUPOS_OBRAS from '@/graphql/querys/administracion/catalogos/grupos.obras/catalogoGruposObras.gql';

export default {
  apollo: {
    catalogoGruposObras: {
      query: OBTENER_GRUPOS_OBRAS,
    },
  },
  methods: {
    async mixAgregarCatalogoGrupoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_GRUPO_OBRA,
        variables: {
          catalogoGrupoObra: this.catalogoGrupoObra,
        },
        update: (store, { data: { agregarCatalogoGrupoObra } }) => {
          const data = store.readQuery({ query: OBTENER_GRUPOS_OBRAS });
          data.catalogoGruposObras.push(agregarCatalogoGrupoObra);
          store.writeQuery({ query: OBTENER_GRUPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixActualizarCatalogoGrupoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_GRUPO_OBRA,
        variables: {
          id: this.catalogoGrupoObraEditar.id,
          catalogoGrupoObra: this.catalogoGrupoObra,
        },
        update: (store, { data: { actualizarCatalogoGrupoObra } }) => {
          const data = store.readQuery({ query: OBTENER_GRUPOS_OBRAS });
          const { catalogoGruposObras } = data;
          const index = catalogoGruposObras
            .findIndex(
              (catalogoGrupoObra) => catalogoGrupoObra.id === actualizarCatalogoGrupoObra.id,
            );
          if (index !== -1) {
            catalogoGruposObras.splice(index, 1, actualizarCatalogoGrupoObra);
          }
          store.writeQuery({ query: OBTENER_GRUPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixEliminarCatalogoGrupoObra(id) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ELIMINAR_GRUPO_OBRA,
        variables: {
          id,
        },
        update: (store) => {
          const data = store.readQuery({ query: OBTENER_GRUPOS_OBRAS });
          data.catalogoGruposObras = data.catalogoGruposObras
            .filter((catalogoGrupoObra) => catalogoGrupoObra.id !== id);
          store.writeQuery({ query: OBTENER_GRUPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
  },
};
